import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import clsx from 'clsx';

import PasswordInput from '../../components/common-inputs/PasswordInput';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import WithError from '../../components/with-error/WithError';
import WithLabel from '../../components/with-label/WithLabel';
import { LABEL_STYLES } from '../../components/with-label/WithLabel';

import scss from './ChangePassword.module.scss';

const ChangePasswordInputWithLabel = ({ name, onChange, label, ...inputProps }) => {
  const { t } = useTranslation('securityPage');

  return (
    <WithLabel label={label} variant={LABEL_STYLES.COLUMN} isBold>
      <Field name={name} autoComplete='new-password'>
        {({ input, meta }) => (
          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
            <div className={scss['input-wrapper']}>
              <PasswordInput
                autoComplete='new-password'
                formProps={input}
                isError={meta.touched && meta.error}
                {...inputProps}
                LeftIcon={<Icon icon={ICONS.Lock} disableCommonStyles />}
              />

              {meta.touched ? (
                <div className={scss['input_icon-wrapper']}>
                  {meta.error ? (
                    <div className={clsx(scss['input_icon-container'], scss['input_icon-container--error'])}>
                      <Icon icon={ICONS.Cross} disableCommonStyles disableCommonColors />
                    </div>
                  ) : (
                    <div className={clsx(scss['input_icon-container'], scss['input_icon-container--success'])}>
                      <Icon icon={ICONS.Tick} disableCommonStyles disableCommonColors />
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          </WithError>
        )}
      </Field>
    </WithLabel>
  );
};

export default ChangePasswordInputWithLabel;
